import { render } from "./S335277.vue?vue&type=template&id=4a76c361"
const script = {}
script.render = render

export default script